<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import index from './index/index.vue'
export default {
  name: 'app',
  components: {
    index,
  }
}
</script>

<style>
*{
		margin: 0;
		padding: 0;
		font-family: '微雅软黑';
	}

	img{
		vertical-align: middle;object-fit: fill;
	}
	[v-cloak] {
	 display: none;
	}
</style>
